import { useEffect, useState } from 'react';
import useEmployeeSkillsService, { CREATE_EMPLOYEE_SKILLS } from '../../useEmployeeSkillsService';
import EmployeeSkillForm from '../../createupdate/EmployeeSkillForm';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { Box } from '@mui/material';
import { ModalFormButton } from 'framework/form';
import { useAuthorization } from 'framework/authorization';
import { useShowContext } from 'framework/show';
import { useFieldHelper } from 'framework/ui/field';
import { mapConfigToValidationShema } from '../../employeeSkillHelpers';
import { SkillsInputsConfig } from '../../types';
import { useIsMyProfile } from 'domain/shared/employee';

const EditSkillsButtonWithModal = () => {
  const isMyProfile = useIsMyProfile();
  const { data, setData = () => {} } = useShowContext();
  const { isGranted } = useAuthorization();
  const { submitSkills } = useEmployeeSkillsService();
  const [validationSchema, setShema] = useState({});
  const { getValue } = useFieldHelper<SkillsInputsConfig>({ source: 'skillsShema' });

  const skillsShema = getValue();

  const skillData = data.getData();

  useEffect(() => {
    const format = mapConfigToValidationShema(skillsShema);
    setShema({
      skills: format,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isGranted(CREATE_EMPLOYEE_SKILLS) || isMyProfile) {
    return null;
  }

  return (
    <>
      <ModalFormButton
        formTitle="Edit skill"
        getValidationSchemaFunc={async () => validationSchema}
        afterSubmit={{
          message: 'You are awesome! The Skills has been successfully updated.',
          execute: response => {
            setData({
              ...skillData,
              ...response,
            });
          },
        }}
        color="transparent"
        label={<AppRegistrationIcon color="primary" />}
        submitFormFunc={submitSkills}
        getDataFunc={async () => skillData}
        paperStyles={{
          background: 'var(--mui-palette-background-paper)',
        }}
        modalSize="sm"
        sxButton={{
          minWidth: 'auto',
          p: 0,
        }}
      >
        <Box
          sx={{
            '.removable-input': {
              mt: '0px !important',
              mb: '10px !important',
            },
            '.removable-input:last-of-type': {
              mb: '15px !important',
            },
          }}
        >
          <EmployeeSkillForm />
        </Box>
      </ModalFormButton>
    </>
  );
};

export default EditSkillsButtonWithModal;
